﻿/**
 * RatingControl.ts
 *
 * A module for a rating control.
 */

import * as Constants from "./../Constants";
import * as Renderer from "./Renderer";

let starId: string = "obf-star";

let starDefinition: Renderer.IUIAsJson = {
	children: [
		{
			attributes: [
				{ name: Constants.AttributeName.Id, value: starId },
				{ name: Constants.AttributeName.X, value: "0" },
				{ name: Constants.AttributeName.Y, value: "0" },
				{ name: Constants.AttributeName.Width, value: "105" },
				{ name: Constants.AttributeName.Height, value: "100" },
				{
					name: Constants.AttributeName.Points,
					value: "52.5, 80.3 84, 100 76.3, 63 105, 38 67.2, 35 52.5, 0 37.8, 35 0, 38 28.7, 63 20, 100 52.5, 80.3",
				},
			],
			id: starId,
			tag: Constants.Tags.Polygon,
		},
	],
	tag: Constants.Tags.Defs,
};

let firstStar: Renderer.IUIAsJson = {
	attributes: [{ name: Constants.AttributeName.xlinkHref, value: `#${starId}` }],
	tag: Constants.Tags.Use,
};

let secondStar: Renderer.IUIAsJson = {
	attributes: [
		{ name: Constants.AttributeName.xlinkHref, value: `#${starId}` },
		{ name: Constants.AttributeName.Transform, value: "translate(105 0)" },
	],
	tag: Constants.Tags.Use,
};

let thirdStar: Renderer.IUIAsJson = {
	attributes: [
		{ name: Constants.AttributeName.xlinkHref, value: `#${starId}` },
		{ name: Constants.AttributeName.Transform, value: "translate(210 0)" },
	],
	tag: Constants.Tags.Use,
};

let fourthStar: Renderer.IUIAsJson = {
	attributes: [
		{ name: Constants.AttributeName.xlinkHref, value: `#${starId}` },
		{ name: Constants.AttributeName.Transform, value: "translate(315 0)" },
	],
	tag: Constants.Tags.Use,
};

let fifthStar: Renderer.IUIAsJson = {
	attributes: [
		{ name: Constants.AttributeName.xlinkHref, value: `#${starId}` },
		{ name: Constants.AttributeName.Transform, value: "translate(420 0)" },
	],
	tag: Constants.Tags.Use,
};

let emptyStars: Renderer.IUIAsJson = {
	attributes: [{ name: Constants.AttributeName.ViewBox, value: "0 0 525 100" }],
	children: [starDefinition, firstStar, secondStar, thirdStar, fourthStar, fifthStar],
	classes: [Constants.Classes.RatingGraphic],
	tag: Constants.Tags.Svg,
};

let oneFilledStar: Renderer.IUIAsJson = {
	attributes: [{ name: Constants.AttributeName.ViewBox, value: "0 0 105 100" }],
	children: [starDefinition, firstStar],
	classes: [Constants.Classes.RatingGraphic, Constants.Classes.RatingGraphicFilled],
	tag: Constants.Tags.Svg,
};

let twoFilledStar: Renderer.IUIAsJson = {
	attributes: [{ name: Constants.AttributeName.ViewBox, value: "0 0 210 100" }],
	children: [starDefinition, firstStar, secondStar],
	classes: [Constants.Classes.RatingGraphic, Constants.Classes.RatingGraphicFilled],
	tag: Constants.Tags.Svg,
};

let threeFilledStar: Renderer.IUIAsJson = {
	attributes: [{ name: Constants.AttributeName.ViewBox, value: "0 0 315 100" }],
	children: [starDefinition, firstStar, secondStar, thirdStar],
	classes: [Constants.Classes.RatingGraphic, Constants.Classes.RatingGraphicFilled],
	tag: Constants.Tags.Svg,
};

let fourFilledStar: Renderer.IUIAsJson = {
	attributes: [{ name: Constants.AttributeName.ViewBox, value: "0 0 420 100" }],
	children: [starDefinition, firstStar, secondStar, thirdStar, fourthStar],
	classes: [Constants.Classes.RatingGraphic, Constants.Classes.RatingGraphicFilled],
	tag: Constants.Tags.Svg,
};

let fiveFilledStar: Renderer.IUIAsJson = {
	attributes: [{ name: Constants.AttributeName.ViewBox, value: "0 0 525 100" }],
	children: [starDefinition, firstStar, secondStar, thirdStar, fourthStar, fifthStar],
	classes: [Constants.Classes.RatingGraphic, Constants.Classes.RatingGraphicFilled],
	tag: Constants.Tags.Svg,
};

export function generate(id: string): Renderer.IUIAsJson {
	return {
		children: [
			emptyStars,
			{
				attributes: [
					{ name: Constants.AttributeName.Type, value: "radio" },
					{ name: Constants.AttributeName.Name, value: id },
					{ name: Constants.AttributeName.Value, value: "1" },
				],
				tag: Constants.Tags.Input,
			},
			oneFilledStar,
			{
				attributes: [
					{ name: Constants.AttributeName.Type, value: "radio" },
					{ name: Constants.AttributeName.Name, value: id },
					{ name: Constants.AttributeName.Value, value: "2" },
				],
				tag: Constants.Tags.Input,
			},
			twoFilledStar,
			{
				attributes: [
					{ name: Constants.AttributeName.Type, value: "radio" },
					{ name: Constants.AttributeName.Name, value: id },
					{ name: Constants.AttributeName.Value, value: "3" },
				],
				tag: Constants.Tags.Input,
			},
			threeFilledStar,
			{
				attributes: [
					{ name: Constants.AttributeName.Type, value: "radio" },
					{ name: Constants.AttributeName.Name, value: id },
					{ name: Constants.AttributeName.Value, value: "4" },
				],
				tag: Constants.Tags.Input,
			},
			fourFilledStar,
			{
				attributes: [
					{ name: Constants.AttributeName.Type, value: "radio" },
					{ name: Constants.AttributeName.Name, value: id },
					{ name: Constants.AttributeName.Value, value: "5" },
				],
				tag: Constants.Tags.Input,
			},
			fiveFilledStar,
		],
		classes: [Constants.Classes.Rating],
		id: id,
		tag: Constants.Tags.Span,
	};
}
